import React from "react";
import Banner from "./Banner";
import ChooseCar from "./ChooseCar";

const Survey = () => {
  return (
    <>
      <Banner />
      <ChooseCar />
    </>
  );
};

export default Survey;
